var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgIcAttachment32 = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 32",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.325 6.536a3.79 3.79 0 0 0-3.79 3.79v4.998l.19-.19a3.485 3.485 0 0 1 4.93 0l4.347 4.346.941-.94a3.486 3.486 0 0 1 4.93 0l3.567 3.566a4 4 0 0 0 .024-.431v-11.35a3.79 3.79 0 0 0-3.79-3.79zM26.51 23.819a5.3 5.3 0 0 0 .454-2.144v-11.35a5.29 5.29 0 0 0-5.29-5.29H10.326a5.29 5.29 0 0 0-5.29 5.29v11.35a5.29 5.29 0 0 0 5.29 5.29h11.35a5.29 5.29 0 0 0 4.835-3.146m-1.619-.14-4.078-4.08a1.986 1.986 0 0 0-2.81 0l-5.864 5.865h9.536a3.79 3.79 0 0 0 3.216-1.786M10.03 25.452l4.911-4.912-4.346-4.346a1.987 1.987 0 0 0-2.81 0l-1.25 1.25v4.23a3.79 3.79 0 0 0 3.495 3.778",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcAttachment32);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };